$(->
  init_rip = (parent)->
    parent.find('.rest-in-place').attr('title', 'Click to Edit').bind('success.rest-in-place', (event, data)->
      $('.update-in-place').each(->
        if $(this).attr('href')
          if $(this).hasClass('send-email')
            $(this).data('to', data.email)
          else
            $(this).attr('href', 'mailto:' + data.email)
          orig_html = $(this).html()
          if orig_html.indexOf('@') > 0
            $(this).html(data.email)
        else
          $(this).html(data[$(this).data('attribute')])
      )
    ).bind('activate.rest-in-place', (event)->
      span = $(event.target)
      if span.html() == '(blank)'
        span.html('')
    )

  init_rip($(document))
  $('.dom_updatable').on('dom_updated', ->
    $(this).find('.rest-in-place').restInPlace()
    init_rip($(this))
  )

  $(document).on 'click', '.panel a.edit-panel', ->
    $(this).closest('.panel').toggleClass('editing')
    return false

)
